module.exports = __webpack_public_path__ + "img/truckImg.5f2e36fa.png";